import { translateField } from "@cdv/jazz-i18n";
import { Button, Card, CardContent, Stack, Typography } from "@mui/material";
import { ReactElement, useContext } from "react";
import AppBar from "../ui/AppBar";
import { Resource } from "../utils";
import { useNavigate } from "react-router";
import { ActionType, AppContext } from "@cdv/jazz-ui";

export default function About(): ReactElement {
  return (
    <>
      <AppBar title={translateField(Resource.Info, "about")} />

      <Card sx={{ mx: "16px", mt: "0 !important", borderRadius: 0, boxShadow: "none" }}>
        <CardContent sx={{ mt: 0 }}>
          <Stack
            sx={{ justifyContent: "center", minHeight: "78vh", mt: "0 !important" }}
            spacing={2}
          >
            <Stack sx={{ alignItems: "center" }}>
              <img src="/assets/ilustr_INFO_02.svg" style={{ height: "184px" }} />
            </Stack>

            <Typography sx={{ textAlign: "center" }}>
              Protistresová aplikace <br /> poskytující psychologické služby <br /> profesionálním
              řidičům{" "}
            </Typography>

            <Typography variant="h5" sx={{ textAlign: "center" }}>
              StressOFF
            </Typography>

            <Typography sx={{ color: "#00000099" }}>
              Jsi řidič, strojvedoucí nebo pracuješ v dopravě? Aplikace ti pomůže lépe zvládat
              stres, předcházet vyhoření a udržet si pohodu i v náročných dnech. Tvoje každodenní
              zkratka do pohody.
            </Typography>

            <Stack sx={{ alignItems: "center", my: "15px" }}>
              <img src="/assets/ilustr_INFO_03_logoTACR.svg" style={{ width: "100%" }} />
            </Stack>

            <Typography sx={{ color: "#00000099" }}>
              Tato aplikace vznikla v rámci projektu PRODRIVE – Psychologické služby pro
              profesionální řidiče (TQ11000034) spolufinancovaného se státní podporou Technologické
              agentury ČR v rámci Programu SIGMA – DC1 (Proof of Concept).
            </Typography>

            <Typography
              sx={{
                textAlign: "center",
                color: "#00000099",
              }}
            >
              Licence: DPMB <br />
              Aktivační klíč: 315 077 <br />
              Stav aktivace: AKTIVNÍ
            </Typography>

            <Typography sx={{ color: "#00000099", textAlign: "center", fontSize: "11px" }}>
              Verze: 1.0.0 <br /> Datum vydání: 19. 9. 2026 <br /> případně poslední aktualizace
            </Typography>

            <Typography sx={{ color: "#00000099", textAlign: "center", fontSize: "11px" }}>
              Autor: kolektiv CDV <br /> Vývoj: kolektiv CDV <br /> Obsah: Metodické centrum <br />{" "}
              Kontakt E-mail: info@stressoff.app <br /> Technická podpora: podpora@cdv.gov.cz <br />{" "}
              Web: stressoff.app
            </Typography>

            <Typography sx={{ color: "#00000099", textAlign: "center", fontSize: "11px" }}>
              © 2026 Centrum dopravního výzkumu
            </Typography>

            <Typography sx={{ color: "#00000099", textAlign: "center", fontSize: "11px" }}>
              Veškerý obsah aplikace, včetně textů, grafiky, audio nahrávek, testů a programového
              kódu, je chráněn autorským právem. Není dovoleno obsah bez souhlasu kopírovat,
              distribuovat nebo dále šířit.
            </Typography>
          </Stack>
        </CardContent>
      </Card>
    </>
  );
}
